import network from "../../../../utils/network";
import { newLogger } from "@/utils/util";

let logger = newLogger("Enterprise-IssueStore");
let generateRequestId = function () {
  return Math.floor(Math.random() * 100000);
};

const urls = {
  issueExport: (key, urlSearchParams) =>
    `/enterprise/issues/export/${encodeURIComponent(
      key
    )}?${urlSearchParams.toString()}`,
};

const initState = () => {
  return {};
};

const actions = {
  export: async ({ dispatch }, { key: key, onlyTime: onlyTime }) => {
    let requestId = generateRequestId();
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.append("onlyTime", onlyTime);
    dispatch(
      "loading/startLoading",
      {
        id: requestId,
        type: "GET",
        url: urls.issueExport(key, urlSearchParams),
        flair: "Jegyek exportálása...",
      },
      { root: true }
    );

    try {
      const axios = await network.excelConnection();
      const { data } = await axios.get(urls.issueExport(key, urlSearchParams));

      dispatch(
        "loading/finishLoading",
        { id: requestId, result: true },
        { root: true }
      );

      return data;
    } catch (err) {
      logger.error(err);
      dispatch(
        "loading/finishLoading",
        { id: requestId, result: false },
        { root: true }
      );
    }
  },
};

const mutations = {};

const getters = {};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
